import { render, staticRenderFns } from "./FooterNavMobile.vue?vue&type=template&id=4d454390&scoped=true"
import script from "./FooterNavMobile.vue?vue&type=script&lang=js"
export * from "./FooterNavMobile.vue?vue&type=script&lang=js"
import style0 from "./FooterNavMobile.vue?vue&type=style&index=0&id=4d454390&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d454390",
  null
  
)

export default component.exports